import {
  MedicalDocumentService,
  useDeleteMedicalDocumentMediumMutation
} from '@/modules/surgicalEvent';
import { useDialogPromise, useErrorDialog } from '@ianesthesie-kit/redux';
import { AppDialogType } from '@/config';
import { InvertedDocumentMedium } from '@/modules/ui';
import { useCallback } from 'react';
import { useCurrentPatientIdParam } from './useCurrentPatientIdParam';

export const useDeleteCurrentPatientMedium = () => {
  const { showErrorDialog } = useErrorDialog();
  const [deleteMedium, { isLoading }] =
    useDeleteMedicalDocumentMediumMutation();
  const { waitForDialog } = useDialogPromise();
  const patientId = useCurrentPatientIdParam();

  const onDelete = useCallback(
    async (medium: InvertedDocumentMedium | undefined) => {
      const doc = medium?.medicalDocument;
      if (!doc || !patientId) {
        return;
      }

      const isDataAssociated =
        doc.extractionStatus === 'PENDING' ||
        doc.extractionStatus === 'COMPLETED';
      const approved =
        !isDataAssociated ||
        MedicalDocumentService.isDeleteWarningMuted ||
        (await waitForDialog({
          dialogType: AppDialogType.MUTE_DELETE_MEDIUM_WARNING,
          message: ''
        }));

      if (approved) {
        deleteMedium({
          patientId,
          document: doc,
          mediumId: medium?.id
        })
          .unwrap()
          .catch(showErrorDialog);
      }
    },
    [deleteMedium, patientId, showErrorDialog, waitForDialog]
  );

  return [onDelete, isLoading] as const;
};
